export default "__VITE_ASSET__BQBPpSwL__"